module.exports = __webpack_public_path__ + "img/icn_support.79c9c2ed.svg";